import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { useLocation } from 'react-router-dom';

import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table
} from "reactstrap";
import SpinnerLoader from '../../constants/SpinnerLoader';
import ErrorModal from '../../constants/ErrorModal';
const AddHelperFlagMaster = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const [errorMessage, setErrorMessage] = useState({});
  const [helperFlag, setHelperFlag] = useState({
    helper_flag_name: '',
    id: null,
  });
  const [editMode, setEditMode] = useState(false)
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });


  const onHandleBackCategory = () => {
    navigate(-1)
  }

  //vali
  const validateInputs = () => {
    const errors = {};

    if (!helperFlag.vendor_master_id) {
      errors.vendor_master_id = 'Vendor is required';
    }

    if (!helperFlag.branch_master_id) {
      errors.branch_master_id = 'Branch is required';
    }

    if (!helperFlag.helper_flag_name) {
      errors.helper_flag_name = 'Flag Name is required';
    }

    return errors;
  };

  const onChangeHandle = (e) => {
    const { name, value } = e.target;
    setHelperFlag((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // if (name === 'helper_flag_name') {
    //   setErrorMessage('');
    // }
  };

  const AddHelperFlag = async () => {

    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage({})
    }


    try {

      // if (!helperFlag.helper_flag_name.trim()) {
      //   setErrorMessage('Flag is required.');
      //   return;
      // }

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.post(`/api/HelperFlagMaster/create`, helperFlag, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        setHelperFlag({
          helper_flag_name: '',
          id: null,
        })
        navigate("/helperFlag")

        // setHelperFlag(response.categoryMasterDetailByID)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    }
  };


  const updateHelperFlag = async (id) => {



    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage({})
    }


    try {

      // if (!helperFlag.helper_flag_name.trim()) {
      //   setErrorMessage('Flag is required.');
      //   return;
      // }

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      let params = {
        helper_flag_name: helperFlag.helper_flag_name
      }

      const response = await apiService.put(`/api/HelperFlagMaster/update?helperFlagId=${id}`, params, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        alert(response.message)
        navigate("/helperFlag")

      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    }
  }

  useEffect(() => {
    if (location.state) {
      setHelperFlag(location.state);
      setEditMode(true)
    }
  }, [location.state]);



  const getVendorName = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.CompanyMasterMasterData)
        if (response.venderMasterData.length == 1 && response.venderMasterData) {

          setVenderMasterTable(response.venderMasterData)
          setHelperFlag((prevDetails) => ({
            ...prevDetails,
            vendor_master_id: response.venderMasterData[0].id,
          }));

        }
        else {
          setVenderMasterTable(response.venderMasterData)
        }
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading(prev => ({ ...prev, vender: false }));
    }
  };

  const getBranchMasterData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const filterName = helperFlag.vendor_master_id ? helperFlag.vendor_master_id : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }


      const response = await apiService.get(`/api/BranchMaster/all?${queryString}`, config);
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {

        if (response.branchMasterData.length == 1 && response.branchMasterData) {

          setBranchMasterTable(response.branchMasterData)
          setHelperFlag((prevDetails) => ({
            ...prevDetails,
            branch_master_id: response.branchMasterData[0].id,
          }));

        }
        else {
          setBranchMasterTable(response.branchMasterData)
          // setHelperFlag((prevDetails) => ({
          //   ...prevDetails,
          //   branch_master_id: null
          // }));
        }

        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
       toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading(prev => ({ ...prev, branch: false }));
    }
  };

  useEffect(() => {
    getVendorName();
    getBranchMasterData();
  }, [helperFlag?.vendor_master_id])


  useEffect(() => {

    const allApisLoaded = Object.values(pageloading).every(status => status === false);
    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.party_branch_vendor_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.party_branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }
  }, [branchMaster, venderMaster, pageloading]);

  if (Object.values(pageloading).some(status => status == true)) {
    return <SpinnerLoader />
  }



  return (
    <>
      <Row>
        <Col>
          <Card className='bg-white pd-10 card-box mb-30'>
            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <i className="bi bi-bell mr-2"></i>
                {
                  editMode ? "Edit Helper Flag Detail" : "Helper Flag Master Detail"
                }
              </div>

              <Button color="warning" size="bg" onClick={onHandleBackCategory} className="ml-auto">
                Back
              </Button>
            </CardTitle>
            <CardBody>
              <Form>


                <Row>

                  <Col xl={12}>
                    {(venderMaster.length === 0 || venderMaster.length > 1) && <FormGroup>
                      <Label for="vendor_master_id">Vendor Name</Label>
                      <Input 
                        type='select'  className="custom-select"
                        id="vendor_master_id"
                        name="vendor_master_id"
                        value={helperFlag.vendor_master_id}
                        onChange={onChangeHandle}
                      >
                        <option value="">Select</option>
                        {venderMaster.map((option) => (
                          <option key={option.id} value={option.id} data-id={option.id}>
                            {option.vender_name}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.vendor_master_id && (
                        <FormText color="danger">{errorMessage.vendor_master_id}</FormText>
                      )}
                    </FormGroup>}
                  </Col>

                  <Col xl={12}>


                    {(branchMaster.length === 0 || branchMaster.length > 1) &&
                      <FormGroup>
                        <Label for="branch_master_id">Branch Name</Label>
                        <Input 
                          type='select'  className="custom-select"
                          id="branch_master_id"
                          name="branch_master_id"
                          value={helperFlag.branch_master_id}
                          onChange={onChangeHandle}
                        >
                          <option value="">Select</option>
                          {branchMaster.map((option) => (
                            <option key={option.id} value={option.id} data-id={option.id}>
                              {option.branch_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.branch_master_id && (
                          <FormText color="danger">{errorMessage.branch_master_id}</FormText>
                        )}
                      </FormGroup>}
                  </Col>
                

                <FormGroup>
                  <Label for="helper_flag_name">Flag Name</Label>
                  <Input 
                    id="helper_flag_name"
                    name="helper_flag_name"
                    onChange={(e) => { onChangeHandle(e) }}
                    value={helperFlag?.helper_flag_name}
                    placeholder="Enter a Flag"
                    type="text"
                  />
                  {errorMessage.helper_flag_name && (
                    <FormText color="danger">{errorMessage.helper_flag_name}</FormText>
                  )}
                </FormGroup>

                </Row>

                {
                  editMode ?
                    <Button type="button" className="mt-2" color="primary" disabled={isSubmitting} onClick={() => updateHelperFlag(helperFlag.id)}>Update</Button>
                    :
                    <Button type="button" className="mt-2" color="primary" disabled={isSubmitting} onClick={() => AddHelperFlag()}>Save</Button>
                }
              </Form>
            </CardBody>



            {/* Error Model */}

            <ErrorModal
              show={showErrorModal}
              title="Validation / Action Required"
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
            // onConfirm={true}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};



export default AddHelperFlagMaster;

